import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import SortableList from './SortableList.js';
import { makeOptions, valueEquals } from './utils.js';
import PropTypes from 'prop-types';
import { SelectSortableBox, SelectBox, StyledSelectContainer, SelectStyles, Button } from './styled.js';
import index from '../../../node_modules/react-select/dist/react-select.browser.esm.js';
import find from '../../../node_modules/ramda/es/find.js';

var SelectSortableDefinition = function SelectSortableDefinition(_ref) {
  var items = _ref.items,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? [] : _ref$selected,
    addHandler = _ref.addHandler,
    removeHandler = _ref.removeHandler,
    sortHandler = _ref.sortHandler,
    selectionHeader = _ref.selectionHeader,
    defaultText = _ref.defaultText,
    noResultsText = _ref.noResultsText;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    currentSelection = _useState2[0],
    setCurrentSelection = _useState2[1];
  var onAddHandler = function onAddHandler() {
    setCurrentSelection("");
    addHandler({
      label: currentSelection
    });
  };
  var onSelectChange = function onSelectChange(_ref2) {
    var value = _ref2.value;
    return setCurrentSelection(value);
  };
  var options = [{
    value: "",
    label: defaultText
  }].concat(_toConsumableArray(makeOptions(items, selected)));
  var value = find(valueEquals(currentSelection))(options);
  return /*#__PURE__*/React__default.createElement(SelectSortableBox, null, /*#__PURE__*/React__default.createElement(SelectBox, null, /*#__PURE__*/React__default.createElement(StyledSelectContainer, null, /*#__PURE__*/React__default.createElement(index, {
    value: value,
    options: options,
    onChange: onSelectChange,
    styles: SelectStyles
  })), /*#__PURE__*/React__default.createElement(Button, {
    disabled: !currentSelection,
    onClick: onAddHandler
  }, "ADD")), /*#__PURE__*/React__default.createElement(SortableList, {
    label: selectionHeader,
    items: selected,
    onSortEnd: sortHandler,
    removeHandler: removeHandler,
    noResultsText: noResultsText
  }));
};
SelectSortableDefinition.displayName = "SelectSortableList";
SelectSortableDefinition.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string
  })).isRequired,
  selected: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string
  })),
  addHandler: PropTypes.func,
  removeHandler: PropTypes.func,
  sortHandler: PropTypes.func,
  selectionHeader: PropTypes.string,
  placeholder: PropTypes.string,
  noResultsText: PropTypes.string
};

export { SelectSortableDefinition as default };
